// relatedStoriesSlider.ts
import Splide, { Options } from '@splidejs/splide';

export function relatedStoriesSlider(): void {
    const splideEls = document.querySelectorAll<HTMLElement>('.splide-related-stories');

    if (splideEls.length === 0) return;

    splideEls.forEach((el) => {
        const options: Options = {
            fixedWidth: '440px',
            gap: '1.5rem',
            pagination: false,
            breakpoints: {
                640: {
                    fixedWidth: '346px',
                },
            },
            arrowPath: 'M 25.912216,34.175412 24.328359,32.647051 35.77786,21.197549 H 0 V 18.977707 H 35.820481 L 24.383855,7.5283613 25.912216,6 40,20.087628 Z',
        };

        const splide = new Splide(el, options);

        // Handle overflow
        splide.on('overflow', (isOverflow: boolean) => {
            splide.options = {
                arrows: isOverflow,
                pagination: isOverflow,
                drag: isOverflow,
            };
        });

        // Handle progress bar
        const bar = el.querySelector<HTMLElement>('.progress-bar');
        splide.on('mounted move', () => {
            const end = splide.Components.Controller.getEnd() + 1;
            const rate = Math.min((splide.index + 1) / end, 1);
            if (bar) {
                bar.style.width = `${100 * rate}%`;
            }
        });

        splide.mount();
    });
}
